import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { ReactComponent as CopyFileIcon } from 'assets/icons/file_copy.svg';

interface CopyButtonProps {
  text: string;
  buttonText?: string;
  copiedText?: string;
}

export const CopyButton = ({ text, buttonText = 'Text kopieren', copiedText = 'Kopiert' }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (navigator?.clipboard) {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    }
  };

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [copied]);

  return (
    <Button
      variant="text"
      size="small"
      endIcon={copied ? <CheckCircle /> : <CopyFileIcon />}
      sx={{ alignSelf: 'flex-start' }}
      onClick={handleCopy}
    >
      {copied ? copiedText : buttonText}
    </Button>
  );
};
